<template>
  <div class="animated fadeIn compras-abm">
    <b-row>
      <b-col xl="12">
        <horizontal-stepper 
          :steps="steps" 
          locale= "es"
          @completed-step="completeStep"
          @active-step="isStepActive" 
          @stepper-finished="registrarOrdenPago"
          :keep-alive="Boolean(true)"
          :top-buttons="Boolean(true)">
        </horizontal-stepper>          
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import HorizontalStepper from 'vue-stepper';
import PagoComprobantes from './PagoComprobantes.vue';
import PagoDocumentos from './PagoDocumentos.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import moment from 'moment'

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'pago/getField',
  mutationType: 'pago/updateField',
});

export default {
  name: 'ABM',
  components: {
    HorizontalStepper,
    PagoComprobantes,
    PagoDocumentos,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  props: {
    impuestos: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      steps: []
    }
  },
  computed: {
    ...mapFields([
      'totalDocumentos',
      'totalSeleccionado',
      'cuentaCorrienteSaldoId'
    ]),
    incluirImpuestosOrganismoEnabled: {
      get: function () {
        return false;
      },
      set: function (newValue) {
      }
    },

  },
  created() {
    // console.log(this.impuestos);

    this.steps = [
      {
          icon: '',
          name: 'pago-comprobantes',
          title: this.impuestos? 'Selección de DD.JJ.' : 'Selección de Proveedores y Comprobantes',
          subtitle: this.impuestos? 'Seleccione el impuesto y las DD.JJ. a incluir' 
            : 'Seleccione el proveedor y los comprobantes a incluir',
          component: PagoComprobantes,
          completed: false

      },
      {
          icon: '',
          name: 'pago-documentos',
          title: 'Ingreso de Documentos',
          subtitle: 'Ingrese los documentos cancelatorios',
          component: PagoDocumentos,
          completed: false
      },
    ]
    
    let params = {
      pagoImpuestos: this.impuestos,
      pagoCuotasPlan: false
    }

    this.$store.dispatch('pago/inicializar', params);
  },  
  methods: {
    completeStep(payload) {
        this.steps.forEach((step) => {
            if (step.name === payload.name) {
                step.completed = true;
            }
        })
    },
    // Executed when @active-step event is triggered
    isStepActive(payload) {
        this.steps.forEach((step) => {
            if (step.name === payload.name) {
                if(step.completed === true) {
                    step.completed = false;
                }
            }
        })
    },
    registrarOrdenPago () {
      let mensaje = 'La orden de pago se registró con éxito';
      if ((/true/i).test(this.impuestos)) {
        mensaje = 'El pago de impuestos se registró con éxito';
      }

      this.showSpinner();
      this.$store.dispatch('pago/save')
        .then(() => this.showModalMsj(mensaje, this.goList, this.goList, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    goList() {
      if ((/true/i).test(this.impuestos)) {
        this.$router.push({ name: 'PagosImpuestos' });
      } else {
        this.$router.push({ name: 'Pagos' });
      }
    },
  },
  watch: {
  },
}
</script>

<style>
</style>
